import { render, staticRenderFns } from "./PercentageUpdate.vue?vue&type=template&id=5a39cd6c&scoped=true&"
import script from "./PercentageUpdate.vue?vue&type=script&lang=js&"
export * from "./PercentageUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PercentageUpdate.vue?vue&type=style&index=0&id=5a39cd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a39cd6c",
  null
  
)

export default component.exports